module.exports = __webpack_public_path__ + "static/img/dynamicx.604e340.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicx.png
// module id = t+ER
// module chunks = 45